
import { assert } from "keycloakify/lib/tools/assert";
import { clsx } from "keycloakify/lib/tools/clsx";



const Input = ({ label, html, htmlFor, type, tabIndex, id, name, defaultValue, otherProps, placholder }) => {
    const device = navigator.platform
    return (
        <div >
            <label className="label" htmlFor="password" >
                {label}
            </label>
            <br />
            {/* {device} */}
            <input
                className={"input"}
                type={type}
                // style={{ width: device === 'Android' ? 300 : 600 }}
                tabIndex={tabIndex}
                id={id}
                html={html}
                name={name}
                {...otherProps}
                defaultValue={defaultValue}
                htmlFor={htmlFor}
                autoComplete="off"
            />
            <br />
            <br />
        </div>
    )
}

export default Input